import React from "react";
import PropTypes from "prop-types";

const Validator = ({ children, isValid, errMsg }) => {
  let modifiedChildren = children;

  if (!isValid) {
    const props = { style: { border: "1px solid #a94442" } };
    modifiedChildren = React.Children.map(
      children,
      (child) =>
        React.isValidElement(child) ? React.cloneElement(child, props) : child,
      this
    );
  }

  return (
    <div>
      {modifiedChildren}
      {!isValid ? <div className="text-danger">{errMsg}</div> : null}
    </div>
  );
};

Validator.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  isValid: PropTypes.bool.isRequired,
  errMsg: PropTypes.string.isRequired,
};

export default Validator;
